import { render } from "./customizerLayout.vue?vue&type=template&id=08f84e50"
import script from "./customizerLayout.vue?vue&type=script&lang=js"
export * from "./customizerLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__